import React, {useState} from 'react';
import {connect, WithStore, MapStateToProps, MapDispatchToProps} from '../../redux/services/Imports';
import {Props} from './interfaces';
import FormContainer from '../FormContainer/FormContainer';
import InputPhone from '../Input/InputPhone';
import Tel from '../Tel/Tel';
import MailTo from '../MailTo/MailTo';
import {ServiceData} from '../../redux/services/ServiceRedux';
import {useSmartCaptcha} from '../SmartCaptcha/useSmartCaptcha';
import SmartCaptchaBox from '../SmartCaptcha/SmartCaptchaBox';
import {ValidationFormItems} from '../../services/GlobalFunctions';
import AgreementCheckboxes from '../AgreementCheckboxes/AgreementCheckboxes';
import './FormVacancies.scss';

const FormVacancies = ({
                         widthWindow,
                         blockedSendLoaded,
                         blockedSend,
                         contactForms
                       }: Props) => {

  const [phoneForm, setPhoneForm] = useState('+7');
  const [errorPhoneForm, setErrorPhoneForm] = useState<string | null>(null);
  const [serverText, setServerText] = useState('');
  const [successShow, setSuccessShow] = useState(false);
  const [disableBtn, setDisableBtn] = useState(false);
  const [showBlockedError, setShowBlockedError] = useState(false);

  const [privacyPolicyAccepted, setPrivacyPolicyAccepted] = useState(false);
  const [allowMarketing, setAllowMarketing] = useState(true);
  const [privacyErrorCount, setPrivacyErrorCount] = useState(0);

  const captcha = useSmartCaptcha(contactForms);

  const handleReCaptchaVerify = async (e: any) => {
    e.preventDefault();

    if (!privacyPolicyAccepted) {
      setPrivacyErrorCount(c => c + 1);
      return;
    }

    setDisableBtn(true);

    setShowBlockedError(false);
    if (blockedSend.state) {
      setShowBlockedError(true);
      setDisableBtn(false);
      return;
    }

    if (!ValidationFormItems({phone: phoneForm, setErrorPhone: setErrorPhoneForm})) {
      setDisableBtn(false);
      return;
    }

    let token = '';
    try {
      token = await captcha.ensureToken();
    } catch {
      setDisableBtn(false);
      return;
    }

    ServiceData.submitForm({
      data: {
        name: 'Кандидат',
        phone: phoneForm,
        allowMarketing
      },
      success,
      setServerText: (t: string) => { setServerText(t); captcha.reset(); setDisableBtn(false); },
      token,
      eventMetrika: 'form_vacancy',
      contactFormId: contactForms.vacancy_contact_form_id
    });
  };

  const success = () => {
    setPhoneForm('+7');

    captcha.reset();
    setSuccessShow(true);
    setTimeout(() => setSuccessShow(false), 3000);
    setDisableBtn(false);
    setPrivacyPolicyAccepted(false);
    setAllowMarketing(true);
    setPrivacyErrorCount(0);
    setErrorPhoneForm(null);
    setServerText('');
  };

  return (
    <div className="form-vacancies">
      <FormContainer
        title="Станьте частью команды Dalli"
        subTitle=""
        image={widthWindow > 720 ? require('./img/image-form.png') : null}
        imageText={`<p class="body1">Рожкова Юлия</p>
            <p class="body2">Менеджер по развитию клиентов</p>`}
        widthRight={widthWindow > 720 ? '500px' : ''}
        buttonText="Стать частью команды"
        buttonWidthAll
        disableBtn={disableBtn}
        showBlockedError={showBlockedError}
        form={
          <>
            <div className="form-vacancies__form-grid">
              <Tel phone="+7 (495) 181-08-31" tag="h4"/>
              <MailTo mail="hr@dalli-service.com" tag="h4"/>
            </div>
            <InputPhone
              label="Телефон*"
              name="phone"
              value={phoneForm}
              onChange={(e: any) => {
                setPhoneForm(e.target.value);
                if (errorPhoneForm) setErrorPhoneForm(null);
                if (serverText) setServerText('');
              }}
              error={errorPhoneForm}
              marginTop={0}
            />
            <AgreementCheckboxes
              privacyChecked={privacyPolicyAccepted}
              onPrivacyChange={(checked) => {
                setPrivacyPolicyAccepted(checked);
                if (checked) setPrivacyErrorCount(0);
              }}
              marketingChecked={allowMarketing}
              onMarketingChange={setAllowMarketing}
              errorTrigger={privacyErrorCount}
            />
            <SmartCaptchaBox captcha={captcha} />
          </>
        }
        onSubmit={handleReCaptchaVerify}
        serverText={serverText}
        successShow={successShow}
        heightSuccessForm="568px"
      />
    </div>
  );
};

// Custom mergeProps to let ownProps override stateProps (fixes contactForms being overwritten by Redux defaults)
const mergeProps = (stateProps: any, dispatchProps: any, ownProps: any) => ({
  ...stateProps,
  ...dispatchProps,
  ...ownProps,
});

export default WithStore()(connect(MapStateToProps, MapDispatchToProps, mergeProps)(FormVacancies));
